/* ============================================================
   Canadian Laser Supply — Theme JS
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* ── STICKY HEADER ── */
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 20);
    }, { passive: true });
  }

  /* ── MOBILE NAV ── */
  var toggle    = document.querySelector('.mobile-menu-toggle');
  var mobileNav = document.querySelector('.mobile-nav');
  var mobileClose = document.querySelector('.mobile-nav-close');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', function () { mobileNav.classList.add('open'); });
    if (mobileClose) mobileClose.addEventListener('click', function () { mobileNav.classList.remove('open'); });
    mobileNav.addEventListener('click', function (e) {
      if (e.target === mobileNav) mobileNav.classList.remove('open');
    });
  }

  /* ── MONEY FORMAT (shared) ── */
  function formatMoney(cents) {
    var fmt = window.shopMoneyFormat || '${{amount}}';
    var dollars = (cents / 100).toFixed(2);
    return fmt
      .replace('{{amount}}', dollars)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100))
      .replace('{{amount_with_comma_separator}}', dollars.replace('.', ','));
  }

  /* ── CART DRAWER ── */
  var cartOverlay = document.getElementById('cart-overlay');
  var cartDrawer  = document.getElementById('cart-drawer');
  var cartClose   = document.getElementById('cart-close');
  var cartBody    = document.getElementById('cart-drawer-body');
  var cartFooter  = document.getElementById('cart-drawer-footer');
  var cartSubtotal = document.getElementById('cart-subtotal-price');

  function openCart() {
    renderCart();
    if (cartOverlay) cartOverlay.classList.add('open');
    if (cartDrawer)  cartDrawer.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    if (cartOverlay) cartOverlay.classList.remove('open');
    if (cartDrawer)  cartDrawer.classList.remove('open');
    document.body.style.overflow = '';
  }

  function renderCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        /* Update header count badge */
        document.querySelectorAll('.cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });

        if (cart.item_count === 0) {
          cartBody.innerHTML =
            '<div class="cart-empty-state">' +
            '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">' +
            '<path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>' +
            '<line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>' +
            '<h3>Your cart is empty</h3>' +
            '<p>Add some laser supplies to get started!</p>' +
            '<a href="/collections/all" class="btn btn-primary" style="margin-top:20px;display:inline-flex;">Shop Now</a>' +
            '</div>';
          if (cartFooter) cartFooter.style.display = 'none';
          return;
        }

        /* Build items HTML */
        var html = '';
        cart.items.forEach(function (item, idx) {
          var imgSrc = item.image ? item.image.replace('.jpg', '_150x150.jpg').replace('.png', '_150x150.png') : '';
          var variantLine = (item.variant_title && item.variant_title !== 'Default Title')
            ? '<div class="cart-item-variant">' + item.variant_title + '</div>'
            : '';
          html +=
            '<div class="cart-item">' +
              (imgSrc ? '<img src="' + imgSrc + '" alt="' + item.title + '" class="cart-item-img">' : '') +
              '<div class="cart-item-body">' +
                '<a href="' + item.url + '" class="cart-item-title">' + item.product_title + '</a>' +
                variantLine +
                '<div class="cart-item-footer">' +
                  '<span class="cart-item-price">' + formatMoney(item.final_line_price) + '</span>' +
                  '<button class="cart-item-remove" data-line="' + (idx + 1) + '">Remove</button>' +
                '</div>' +
              '</div>' +
            '</div>';
        });
        cartBody.innerHTML = html;

        /* Remove buttons */
        cartBody.querySelectorAll('.cart-item-remove').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var line = btn.dataset.line;
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ line: parseInt(line, 10), quantity: 0 })
            }).then(function () { renderCart(); });
          });
        });

        /* Footer */
        if (cartFooter) cartFooter.style.display = 'block';
        if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.total_price);
      })
      .catch(function (err) { console.error('Cart fetch error', err); });
  }

  document.querySelectorAll('[data-cart-trigger]').forEach(function (t) {
    t.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
  });
  if (cartClose)   cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  /* Initial cart count */
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      document.querySelectorAll('.cart-count').forEach(function (el) {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    }).catch(function () {});

  /* ── ADD TO CART ── */
  document.querySelectorAll('[data-atc]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var variantId = btn.dataset.variantId;
      if (!variantId) return;
      var qtyInput = document.querySelector('.qty-input');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

      btn.disabled = true;
      var original = btn.innerHTML;
      btn.innerHTML = 'Adding&hellip;';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty })
      })
      .then(function (res) {
        if (res.ok) {
          btn.innerHTML = '&#10003; Added!';
          btn.style.background = '#38A169';
          setTimeout(function () {
            btn.innerHTML = original;
            btn.style.background = '';
            btn.disabled = false;
          }, 1600);
          openCart(); /* renders fresh cart */
        } else {
          return res.json().then(function (data) {
            btn.innerHTML = data.description || 'Out of Stock';
            btn.style.background = '#E53E3E';
            setTimeout(function () { btn.innerHTML = original; btn.style.background = ''; btn.disabled = false; }, 2200);
          });
        }
      })
      .catch(function () {
        btn.innerHTML = original;
        btn.disabled = false;
      });
    });
  });

  /* ── VARIANT SELECTION (product page) ── */
  /* Use /products/handle.js for live inventory — never the Liquid-rendered JSON */
  var numOptions = window.productNumOptions || 0;

  if (numOptions > 0 && window.productHandle) {

    var variants       = null;
    var selectedOptions = [];

    function findVariant(opts) {
      if (!variants) return null;
      return variants.find(function (v) {
        for (var j = 0; j < numOptions; j++) {
          if (v['option' + (j + 1)] !== opts[j]) return false;
        }
        return true;
      }) || null;
    }

    function updatePrice(variant) {
      var priceEl   = document.getElementById('price-current');
      var compareEl = document.getElementById('price-compare');
      var atcBtn    = document.getElementById('btn-atc');

      if (!variant) {
        if (priceEl)   priceEl.textContent = 'Unavailable';
        if (compareEl) compareEl.style.display = 'none';
        if (atcBtn) {
          atcBtn.disabled = true;
          atcBtn.textContent = 'Unavailable';
          atcBtn.style.background = 'var(--cls-gray)';
          atcBtn.style.cursor = 'not-allowed';
        }
        return;
      }

      if (priceEl) {
        priceEl.textContent = formatMoney(variant.price);
        priceEl.className   = 'price' + (variant.compare_at_price > variant.price ? ' price-sale' : '');
      }
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent   = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      if (atcBtn) {
        atcBtn.dataset.variantId = String(variant.id);
        if (variant.available) {
          atcBtn.disabled = false;
          atcBtn.style.background = '';
          atcBtn.style.cursor     = '';
          atcBtn.innerHTML =
            '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">' +
            '<path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>' +
            '<line x1="3" y1="6" x2="21" y2="6"/>' +
            '<path d="M16 10a4 4 0 01-8 0"/></svg> Add to Cart';
        } else {
          atcBtn.disabled = true;
          atcBtn.style.background = 'var(--cls-gray)';
          atcBtn.style.cursor     = 'not-allowed';
          atcBtn.textContent      = 'Sold Out';
        }
      }
    }

    function handleOptionChange(optionIndex, value) {
      selectedOptions[optionIndex] = value;

      /* Update label */
      var labelEl = document.getElementById('option-label-' + optionIndex);
      if (labelEl) labelEl.textContent = value;

      /* Highlight active swatch/chip in this group only */
      var group = document.querySelector('[data-option-group="' + optionIndex + '"]');
      if (group) {
        group.querySelectorAll('.swatch-lg, .size-chip').forEach(function (el) {
          el.classList.toggle('active', el.dataset.value === value);
        });
      }

      updatePrice(findVariant(selectedOptions));
    }

    /* Attach click handlers straight away — variants may not be loaded yet,
       handleOptionChange guards with findVariant returning null safely */
    document.querySelectorAll('[data-option].swatch-lg, [data-option].size-chip').forEach(function (el) {
      el.addEventListener('click', function () {
        var optIdx = parseInt(el.dataset.option, 10);
        if (isNaN(optIdx)) return;
        handleOptionChange(optIdx, el.dataset.value);
      });
    });

    /* ── Fetch live variant data from Shopify storefront ── */
    fetch('/products/' + window.productHandle + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error('product.js fetch failed: ' + r.status);
        return r.json();
      })
      .then(function (data) {
        variants = data.variants;

        /* Initialize selectedOptions from the URL-selected (or first available) variant */
        var initVar = variants.find(function (v) { return v.id === window.currentVariantId; });
        if (!initVar) initVar = variants.find(function (v) { return v.available; });
        if (!initVar) initVar = variants[0];

        for (var i = 0; i < numOptions; i++) {
          selectedOptions[i] = initVar['option' + (i + 1)];
        }

        /* Sync initial display to what's actually available */
        updatePrice(initVar);
      })
      .catch(function (err) {
        console.warn('Canadian Laser Supply theme: variant fetch failed.', err);
      });

  } /* end variant block */

  /* ── PRODUCT GALLERY THUMBNAILS ── */
  var mainImg = document.querySelector('#main-product-image');
  document.querySelectorAll('.product-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      document.querySelectorAll('.product-thumb').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      if (mainImg && thumb.dataset.src) {
        mainImg.style.opacity = '0';
        mainImg.style.transition = 'opacity 0.2s';
        setTimeout(function () { mainImg.src = thumb.dataset.src; mainImg.style.opacity = '1'; }, 200);
      }
    });
  });

  /* ── PRODUCT CARD SWATCHES ── */
  document.querySelectorAll('.product-card .swatch').forEach(function (sw) {
    sw.addEventListener('click', function () {
      var swatches = sw.closest('.product-swatches');
      if (swatches) swatches.querySelectorAll('.swatch').forEach(function (s) { s.classList.remove('active'); });
      sw.classList.add('active');
      var img = sw.closest('.product-card') ? sw.closest('.product-card').querySelector('.product-card-image img') : null;
      if (img && sw.dataset.img) img.src = sw.dataset.img;
    });
  });

  /* ── QUANTITY SELECTOR ── */
  document.querySelectorAll('.qty-selector').forEach(function (sel) {
    var input = sel.querySelector('.qty-input');
    var minus = sel.querySelector('.qty-minus');
    var plus  = sel.querySelector('.qty-plus');
    if (minus && input) minus.addEventListener('click', function () {
      var v = parseInt(input.value, 10);
      if (v > 1) input.value = v - 1;
    });
    if (plus && input) plus.addEventListener('click', function () {
      input.value = parseInt(input.value, 10) + 1;
    });
  });

  /* ── SCROLL REVEAL ── */
  if ('IntersectionObserver' in window) {
    var revealEls = document.querySelectorAll('.product-card, .category-card, .trust-badge');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function (el, i) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.45s ease ' + (i * 0.05) + 's, transform 0.45s ease ' + (i * 0.05) + 's';
      io.observe(el);
    });
  }

});
